import { Tab } from "../helper-classes/Tab";

export const crewLeaderDashboardTabs = [
  new Tab("my tasks", "my-tasks", "fal fa-ballot fa-fw", 3),
  new Tab("work orders", "work-orders", "fal fa-hard-hat fa-fw", 3),
  new Tab(
    "scheduled deliveries",
    "scheduled-deliveries",
    "fal fa-shuttle-van fa-fw",
    3
  ),
  new Tab(
    "delivered procurements",
    "delivered-procurements",
    "fal fa-box-check fa-fw",
    3
  ),
  new Tab(
    "cancelled deliveries",
    "cancelled-deliveries",
    "fal fa-times-circle fa-fw",
    3
  )
];
export const adminDashboardTabs = [
  new Tab("crews scheduled", "crews-scheduled", "bdg-icon hardhat-goggles")
];
export const crewSupervisorDesignerDashboardTabs = [
  new Tab("my tasks", "my-tasks", "fal fa-ballot fa-fw", 3),
  new Tab("work orders", "work-orders", "fal fa-hard-hat fa-fw", 3)
];
